module.exports = " <svg-icon class=file-icon :type=type :name=name></svg-icon> ";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-html-loader!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/statamic/resources/js/components/FileIcon.vue
// module id = 497
// module chunks = 0